export function getFirebaseTargetEnv(env: Env): string {
  const ENV_MAPPINGS: Record<string, string> = {
    dtg: 'dtg',
    stg: 'stg',
    dev: 'dev',
    prd: '',
    rtg: 'rtg',
  };

  return ENV_MAPPINGS[env];
}
